export const ENTITIES_ARCHIVE_MODAL_PARAM = 'entitiesArchiveModal';
